<template>
  <q-input
    v-model="obj.value"
    outlined
    dense
    autogrow
    :label="showLabel ? 'Value' : undefined"
    :hint="showDescription ? metadataDefault.description : undefined"
  >
    <q-menu
      v-if="hasDropdownOptions"
      no-refocus
      no-focus
      fit
    >
      <q-list dense>
        <q-item-wrapper
          v-for="(opt, key) in metadataDefault.dropdown_options"
          :key="key"
          v-close-popup
          clickable
          :active="isOptionSelected(opt)"
          @click="selectDropdownOption(opt)"
        >
          <nl2br :text="opt.value" />
        </q-item-wrapper>
      </q-list>
    </q-menu>

    <template #after>
      <cancel-button
        flat
        @click="$emit('remove')"
      />
    </template>

    <template v-if="hasDropdownOptions" #append>
      <q-icon name="mdi-menu-down" />
    </template>
  </q-input>
</template>

<script>
import { checkDropdownOptionIsSelected, selectDropdownOption } from 'components/partials/metadata/metadataMixin'

export default {
  props: {
    metadataDefault: {
      type: Object,
      default: null
    },
    obj: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    showDescription: {
      type: Boolean,
      default: false
    },
    hasDropdownOptions: {
      type: Boolean,
      default: false
    }
  },
  emits: ['remove'],
  methods: {
    isOptionSelected (opt) {
      return checkDropdownOptionIsSelected(this.obj, opt)
    },
    selectDropdownOption (opt) {
      selectDropdownOption(this.obj, opt)
    }
  }
}
</script>
